import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_REQUEST_FOR_FUNDS_Mapper extends BaseFormMapper<CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_REQUEST_FOR_FUNDS> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_REQUEST_FOR_FUNDS,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_REQUEST_FOR_FUNDS);

		return _formData;
	}

	MapValues(): Partial<CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_REQUEST_FOR_FUNDS> {
		return {};
	}
}

const Mappings: CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_REQUEST_FOR_FUNDS =
	{
		// "0":"ButtonSubmit0",
		signature: 'Text121',
		date: 'Text120',
		faxNumber: 'Text119',
		lawfirmAddress: 'Text118',
		telephoneNumber: 'Text117',
		lawfirmName: 'Text116',
		trustNumber: 'Text115',
		fundsDateRequired: 'Text114',
		transitNumber: 'Text113',
		amountRequisitioned: 'Text112',
		bankName: 'Text111',
		interestAdjustmentDate: 'Text110',
		mortgageAmount: 'Text109',
		annualTaxAmount: 'Text108',
		rollNumber: 'Text107',
		municipalTaxOffice: 'Text106',
		legalDescription: 'Text105',
		propertyAddress: 'Text104',
		mortgagor: 'Text103',
		referenceNumber: 'Text102',
		re: 'Text101',
	};

export interface CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_REQUEST_FOR_FUNDS {
	referenceNumber: string;
	re: string;

	mortgagor: string;
	propertyAddress: string;
	legalDescription: string;

	municipalTaxOffice: string;
	rollNumber: string;
	annualTaxAmount: string;

	mortgageAmount: string;
	interestAdjustmentDate: string;

	bankName: string;
	amountRequisitioned: string;

	transitNumber: string;
	fundsDateRequired: string;
	trustNumber: string;

	lawfirmName: string;
	telephoneNumber: string;
	lawfirmAddress: string;
	faxNumber: string;

	date: string;
	signature: string;
}
